module.exports = __webpack_public_path__ + "img/Circle_Arrow_Blue.6cd7de21.svg";